import {ColumnDefinition} from 'features/gridReport/models';
import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

interface OffCanvasFiltersProps {
  offCanvasFilters: ColumnDefinition[];
  renderFilterComponent: (item: ColumnDefinition) => React.ReactNode;
}

export const OffCanvasFilters: React.FC<OffCanvasFiltersProps> = ({
  offCanvasFilters,
  renderFilterComponent,
}) => {



  return (
    <Container fluid>
      <Row>
        {offCanvasFilters.map(item => (
          <Col key={String(item.field)} xs={12} className="mb-3">
            {renderFilterComponent(item)}
          </Col>
        ))}
      </Row>
    </Container>
  );
};
